import gql from 'graphql-tag';

export const LOCATION_FRAGMENT = gql`
    fragment LOCATION_FRAGMENT on ListingLocation {
        coordinates {
            latitude
            longitude
        }
    }
`;
